import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface PortalStateProps {
  title: string;
  description?: ReactNode;
  children?: ReactNode;
  loading?: boolean;
  className?: string;
}

export function PortalState({
  title,
  description,
  children,
  loading = false,
  className,
}: PortalStateProps) {
  return (
    <main
      aria-busy={loading}
      aria-live={loading ? "polite" : undefined}
      className={cn(
        "flex min-h-screen items-center justify-center bg-muted/30 p-4 text-center sm:p-6",
        className
      )}
    >
      <Card className="w-full max-w-sm">
        <CardHeader className="items-center gap-3 p-5 pb-3">
          <div
            aria-hidden="true"
            className="flex size-9 items-center justify-center rounded-md bg-primary text-sm font-bold text-primary-foreground"
          >
            E
          </div>
          {loading && (
            <span role="status" aria-label={title}>
              <Loader2 className="size-5 animate-spin text-primary" />
            </span>
          )}
          <CardTitle className="text-lg leading-6 tracking-normal">
            <h1>{title}</h1>
          </CardTitle>
          {description && (
            <CardDescription className="leading-5">
              {description}
            </CardDescription>
          )}
        </CardHeader>
        {children && (
          <CardContent className="flex justify-center p-5 pt-1">
            {children}
          </CardContent>
        )}
      </Card>
    </main>
  );
}
